// **************************************************
// Tooltip
// **************************************************

// const inputTooltips = document.querySelectorAll('.tooltip-btn');

// inputTooltips.forEach((inputTooltip) => {
//   inputTooltip.addEventListener('click', () => {
//     const parent = inputTooltip.closest('.tooltip');
//     parent.classList.toggle('is-active');
//   });
// });
